import React from "react";
import styles from '../addCategoryForm/addCategoryForm.module.css';
import { Add, Close, Delete } from "../../Svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

const AddVariantsForm = () => {
    
    const navigate = useNavigate()
    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm
    } = useFormik({
        initialValues: {
            variant_name: "",
            variation_value: [""],
            status: "",
        },
        validationSchema: Yup.object({
            variant_name: Yup.string().required("Variant Type is required"),
            status: Yup.string().required("Status is required"),
        }),
        onSubmit: async (values) => {
            // console.log("Form submitted:", values);
            try {
                const { data, status } = await api.addAtributes(values)
                if (status == 200) {
                    console.log(data);
                    toast.success(data?.data?.message)
                    navigate(-1)
                }
            } catch (err) {
                console.log(err);
                toast.error(err?.response?.data?.message || 'something went wrong')
            }
        },
    });

    const handleAddVariantField = () => {
        setFieldValue("variation_value", [...values.variation_value, ""]);
    };

    const handleVariantValueChange = (index, value) => {
        const updatedValues = [...values.variation_value];
        updatedValues[index] = value;
        setFieldValue("variation_value", updatedValues);
    };

    const handleRemoveVariantField = (index) => {
        const updatedValues = [...values.variation_value];
        updatedValues.splice(index, 1);
        setFieldValue("variation_value", updatedValues);
    };

    return (
        <>
            <div className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Variation</h2>

                            {/* Variant Type Input */}
                            <label className={styles.addCatLabel}>
                                Variant Type/Name
                                <input
                                    type="text"
                                    name="variant_name"
                                    placeholder="Type category name here..."
                                    className={styles.addCatInput}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.variant_name}
                                />
                                {touched.variant_name &&
                                    errors.variant_name && (
                                        <div className={styles.errorText}>
                                            {errors.variant_name}
                                        </div>
                                    )}
                            </label>

                            {/* Display Existing Variant Value Fields */}
                            {values.variation_value.map((value, index) => (
                                <label key={index} className={styles.addCatLabel}>
                                    Variation Value {index + 1}
                                    <div
                                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                    >
                                        <input
                                            type="text"
                                            className={styles.addCatInput}
                                            value={value}
                                            placeholder="variant_value"
                                            onChange={(e) =>
                                                handleVariantValueChange(index, e.target.value)
                                            }
                                        />
                                        {values.variation_value.length > 1 && (
                                            <button style={{ border: 'none', borderRadius: '8px' }}
                                                type="button"
                                                onClick={() => handleRemoveVariantField(index)}
                                            >
                                                <Delete />
                                            </button>
                                        )}
                                    </div>
                                    {errors.variation_value &&
                                        errors.variation_value[index] && (
                                            <div className={styles.errorText}>
                                                {errors.variation_value[index]}
                                            </div>
                                        )}
                                </label>
                            ))}

                            {/* Add New Variant Field */}
                            <button
                                type="button"
                                className={styles.addVar}
                                onClick={handleAddVariantField}
                                style={{ cursor: 'pointer' }}
                            >
                                <Add /> Add Variant
                            </button>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className={styles.buttonGroup}>
                        <button
                            type="button"
                            className={styles.cancelButton}
                            onClick={resetForm}
                        >
                            <Close /> Cancel
                        </button>
                        <button
                            type="submit"
                            className={styles.updateButton}
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "please wait..." : "Save"}
                        </button>
                    </div>
                </div>

                {/* Status Dropdown */}
                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Status</h2>
                        <label className={styles.addCatLabel}>
                            Category Status*
                            <select
                                name="status"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.status}
                            >
                                <option value="">Select...</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                            {touched.status && errors.status && (
                                <div className={styles.errorText}>{errors.status}</div>
                            )}
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddVariantsForm;
